type TextType = {
  shortText: string;
  longText: string;
};

export const path_and_hero_text: Record<string, TextType> = {
  "/about-us": {
    shortText: "about us",
    longText:
      "Learn about our story, mission and values to excellence in medical education",
  },
  "/accreditation": {
    shortText: "accreditation",
    longText: "OICNM's Accreditation Journey",
  },
  "/admission": {
    shortText: "admission",
    longText: "Unlock your future, explore admission opportunities",
  },

  // "/alumni": {
  //   shortText: "our alumni",
  //   longText: "Connect, Reunite, and Thrive, Alumni Hub",
  // },
  "/alumni": {
    shortText: "",
    longText: "",
  },

  "/career": {
    shortText: "career",
    longText: "Chart Your Path to Success, Explore Career Opportunities",
  },
  "/college-leadership": {
    shortText: "PRINCIPAL OFFICERS",
    longText: "Shaping Futures, Inspiring Excellence!",
  },
  "/downloads": {
    shortText: "downloads",
    longText: "Resource Repository",
  },
  "/events": {
    shortText: "events",
    longText: "Discover the Pulse of Campus Life: Explore Our Vibrant Events!",
  },
  "/examination-grading-system": {
    shortText: "examination and grading system",
    longText: "Explore Our Examination and Grading System",
  },
  "/faculty-members": {
    shortText: "faculty members",
    longText: "Meet Our Esteemed Faculty: Leaders in Education and Innovation",
  },
  "/foreign-students": {
    shortText: "foreign students",
    longText: "Welcoming International Scholars to Our Campus Community",
  },
  "/gallery": {
    shortText: "gallery",
    longText: "A Visual Journey Through Our College Experience",
  },
  "/programmes": {
    shortText: "programmes",
    longText: "Below are the different available programmes at OICNM",
  },
  "/results": {
    shortText: "oicnm",
    longText: "Search Results",
  },
  "/scholarship": {
    shortText: "scholarship and financial aids",
    longText: "Unlock your future, explore admission opportunities",
  },
  "/tuition-fees": {
    shortText: "tuition fees",
    longText: "Unveiling Our Transparent Tuition Fees Structure",
  },
};
